// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll_b88c777e {
  position: relative;
  top: 0.667rem;
  height: calc(100% - 1.334rem);
  width: 0.667rem;
  border-radius: 0.667rem;
  margin: 0 0.334rem;
  overflow: hidden;
  z-index: 11;
}
.scroll_horizontal_b88c777e {
  top: auto;
  left: 0.667rem;
  width: calc(100% - 1.334rem);
  height: 0.667rem;
  margin: 0.334rem 0;
}
.scroll_horizontal_b88c777e .scroll__handle_b88c777e {
  min-width: 2.667rem;
  right: auto;
  bottom: 0;
  min-height: 0;
  cursor: pointer;
}
.scroll_light_b88c777e {
  background-color: #eaedef;
}
.scroll_light_b88c777e .scroll__handle_b88c777e {
  background-color: #84919b;
}
.scroll_light_b88c777e .scroll__handle_b88c777e:active,
.scroll_light_b88c777e .scroll__handle_b88c777e:hover {
  background-color: #657682;
}
.scroll_dark_b88c777e {
  background-color: #84919b;
}
.scroll_dark_b88c777e .scroll__handle_b88c777e {
  background-color: #eaedef;
}
.scroll_dark_b88c777e .scroll__handle_b88c777e:active,
.scroll_dark_b88c777e .scroll__handle_b88c777e:hover {
  background-color: #eaedef;
}
.scroll__handle_b88c777e {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: 2.667rem;
  border-radius: 0.667rem;
}
.scrollable_b88c777e {
  position: relative;
  max-width: 100%;
  height: 100%;
  touch-action: none;
}
.scrollable_enabled_b88c777e {
  overflow: hidden;
}
.scrollable_with-arrows_b88c777e:hover.scrollable_start_b88c777e::before {
  opacity: 0;
}
.scrollable_with-arrows_b88c777e:hover.scrollable_end_b88c777e::after {
  opacity: 0;
}
.scrollable_with-arrows_b88c777e:hover .scrollable__arrow_b88c777e {
  opacity: 1;
}
.scrollable__container_b88c777e {
  position: relative;
}
.scrollable__container_moving_b88c777e {
  transition: margin 0.3s ease-out;
}
.scrollable_overlay_b88c777e {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
  display: none;
  user-select: none;
}
.scrollable_horizontal_b88c777e::before,
.scrollable_horizontal_b88c777e::after {
  content: '';
  position: absolute;
  opacity: 0;
  transition: opacity 0.3s linear;
  pointer-events: none;
  z-index: 1;
}
.scrollable_horizontal_b88c777e.scrollable_start_b88c777e::before {
  opacity: 1;
}
.scrollable_horizontal_b88c777e.scrollable_end_b88c777e::after {
  opacity: 1;
}
.scrollable_vertical_b88c777e::before,
.scrollable_vertical_b88c777e::after {
  content: '';
  position: absolute;
  opacity: 0;
  transition: opacity 0.3s linear;
  pointer-events: none;
  z-index: 1;
}
.scrollable_vertical_b88c777e.scrollable_start_b88c777e::before {
  opacity: 1;
}
.scrollable_vertical_b88c777e.scrollable_end_b88c777e::after {
  opacity: 1;
}
.scrollable_horizontal_b88c777e.scrollable_with-scroll-line_b88c777e:not(.scrollable_absolute_b88c777e) {
  padding-bottom: 1.334rem;
}
.scrollable_horizontal_b88c777e.scrollable_with-scroll-line_b88c777e:not(.scrollable_absolute_b88c777e)::before,
.scrollable_horizontal_b88c777e.scrollable_with-scroll-line_b88c777e:not(.scrollable_absolute_b88c777e)::after {
  bottom: 1.334rem;
}
.scrollable_horizontal_b88c777e > .scrollable__container_b88c777e {
  float: left;
  min-width: 100%;
}
body:not(.with-outline) .scrollable_horizontal_b88c777e > .scrollable__container_b88c777e:focus {
  outline: none;
}
.scrollable_horizontal_b88c777e::before,
.scrollable_horizontal_b88c777e::after {
  top: 0;
  bottom: 0;
  width: 4.000999999999999rem;
}
.scrollable_horizontal_b88c777e::before {
  left: 0;
}
.scrollable_horizontal_b88c777e::after {
  right: 0;
}
.scrollable_horizontal_b88c777e.scrollable_shadow-light_b88c777e::before {
  background-image: linear-gradient(to left, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_horizontal_b88c777e.scrollable_shadow-light_b88c777e::after {
  background-image: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_horizontal_b88c777e.scrollable_shadow-dark_b88c777e::before {
  background-image: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_horizontal_b88c777e.scrollable_shadow-dark_b88c777e::after {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_vertical_b88c777e.scrollable_with-scroll-line_b88c777e:not(.scrollable_absolute_b88c777e) {
  padding-right: 1.334rem;
}
.scrollable_vertical_b88c777e.scrollable_with-scroll-line_b88c777e:not(.scrollable_absolute_b88c777e)::before,
.scrollable_vertical_b88c777e.scrollable_with-scroll-line_b88c777e:not(.scrollable_absolute_b88c777e)::after {
  right: 1.334rem;
}
body:not(.with-outline) .scrollable_vertical_b88c777e .scrollable__container_b88c777e:focus {
  outline: none;
}
.scrollable_vertical_b88c777e::before,
.scrollable_vertical_b88c777e::after {
  height: 3.001rem;
  left: 0;
  right: 0;
}
.scrollable_vertical_b88c777e::before {
  top: 0;
}
.scrollable_vertical_b88c777e::after {
  bottom: 0;
}
.scrollable_vertical_b88c777e.scrollable_shadow-light_b88c777e::before {
  background-image: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_vertical_b88c777e.scrollable_shadow-light_b88c777e::after {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.12));
}
.scrollable_vertical_b88c777e.scrollable_shadow-dark_b88c777e::before {
  background-image: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.4));
}
.scrollable_vertical_b88c777e.scrollable_shadow-dark_b88c777e::after {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.4));
}
.scrollable_absolute_b88c777e > .scroll_b88c777e {
  opacity: 0;
  transition: opacity 0.3s linear;
}
.scrollable_absolute_b88c777e > .scroll_dragging_b88c777e {
  opacity: 1;
}
.scrollable_absolute_b88c777e:hover > .scroll_b88c777e {
  opacity: 1;
}
.scrollable_b88c777e > .scroll_b88c777e {
  position: absolute;
  right: 0;
  left: auto;
  top: 0.667rem;
  bottom: 0.667rem;
  height: auto;
}
.scrollable_b88c777e > .scroll_horizontal_b88c777e {
  top: auto;
  bottom: 0;
  left: 0.667rem;
  right: 0.667rem;
  height: 0.667rem;
  width: auto;
}
.scrollable__arrow_b88c777e {
  position: absolute;
  z-index: 10;
  font-size: 2.167rem;
  width: 4rem;
  height: 100%;
  background-color: rgba(132,145,155,0.4);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease-in;
}
.scrollable__arrow_b88c777e:hover,
.scrollable__arrow_active_b88c777e {
  background-color: rgba(132,145,155,0.4);
}
.scrollable__arrow_b88c777e:hover ~ .scrollable__container_b88c777e,
.scrollable__arrow_active_b88c777e ~ .scrollable__container_b88c777e {
  will-change: margin;
}
.scrollable__arrow_left_b88c777e {
  left: 0;
}
.scrollable__arrow_right_b88c777e {
  right: 0;
}
.scrollable__arrow_right_b88c777e .scrollable__arrow-icon_b88c777e {
  transform: translate(100%, -50%);
}
.scrollable__arrow-icon_b88c777e {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `scroll_b88c777e`,
	"scroll_horizontal": `scroll_horizontal_b88c777e`,
	"scroll__handle": `scroll__handle_b88c777e`,
	"scroll_light": `scroll_light_b88c777e`,
	"scroll_dark": `scroll_dark_b88c777e`,
	"scrollable": `scrollable_b88c777e`,
	"scrollable_enabled": `scrollable_enabled_b88c777e`,
	"scrollable_with-arrows": `scrollable_with-arrows_b88c777e`,
	"scrollable_start": `scrollable_start_b88c777e`,
	"scrollable_end": `scrollable_end_b88c777e`,
	"scrollable__arrow": `scrollable__arrow_b88c777e`,
	"scrollable__container": `scrollable__container_b88c777e`,
	"scrollable__container_moving": `scrollable__container_moving_b88c777e`,
	"scrollable_overlay": `scrollable_overlay_b88c777e`,
	"scrollable_horizontal": `scrollable_horizontal_b88c777e`,
	"scrollable_vertical": `scrollable_vertical_b88c777e`,
	"scrollable_with-scroll-line": `scrollable_with-scroll-line_b88c777e`,
	"scrollable_absolute": `scrollable_absolute_b88c777e`,
	"scrollable_shadow-light": `scrollable_shadow-light_b88c777e`,
	"scrollable_shadow-dark": `scrollable_shadow-dark_b88c777e`,
	"scroll_dragging": `scroll_dragging_b88c777e`,
	"scrollable__arrow_active": `scrollable__arrow_active_b88c777e`,
	"scrollable__arrow_left": `scrollable__arrow_left_b88c777e`,
	"scrollable__arrow_right": `scrollable__arrow_right_b88c777e`,
	"scrollable__arrow-icon": `scrollable__arrow-icon_b88c777e`
};
export default ___CSS_LOADER_EXPORT___;
